import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, NativeSelect, InputLabel } from '@material-ui/core';

const styles = theme => ({
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 200,
        marginLeft: 0
    }
});

export default withStyles(styles)(class StateSelectField extends Component {
    
    // need to read all of the states and on init
    constructor(props) {
        super(props);
        this.states = {
            "AL": "Alabama",
            "AK": "Alaska",
            "AZ": "Arizona",
            "AR": "Arkansas",
            "CA": "California",
            "CO": "Colorado",
            "CT": "Connecticut",
            "DE": "Delaware",
            "DC": "District Of Columbia",
            "FL": "Florida",
            "GA": "Georgia",
            "HI": "Hawaii",
            "ID": "Idaho",
            "IL": "Illinois",
            "IN": "Indiana",
            "IA": "Iowa",
            "KS": "Kansas",
            "KY": "Kentucky",
            "LA": "Louisiana",
            "ME": "Maine",
            "MD": "Maryland",
            "MA": "Massachusetts",
            "MI": "Michigan",
            "MN": "Minnesota",
            "MS": "Mississippi",
            "MO": "Missouri",
            "MT": "Montana",
            "NE": "Nebraska",
            "NV": "Nevada",
            "NH": "New Hampshire",
            "NJ": "New Jersey",
            "NM": "New Mexico",
            "NY": "New York",
            "NC": "North Carolina",
            "ND": "North Dakota",
            "OH": "Ohio",
            "OK": "Oklahoma",
            "OR": "Oregon",
            "PA": "Pennsylvania",
            "RI": "Rhode Island",
            "SC": "South Carolina",
            "SD": "South Dakota",
            "TN": "Tennessee",
            "TX": "Texas",
            "UT": "Utah",
            "VT": "Vermont",
            "VA": "Virginia",
            "WA": "Washington",
            "WV": "West Virginia",
            "WI": "Wisconsin",
            "WY": "Wyoming"
        };
    }

    handleChange = (event) => {
        this.props.onChange({
            target: {
                id: event.target.name,
                value: event.target.value
            }
        })
    }

    menuItems() {
        return Object.keys(this.states).map((key) => (
            <option value={key} key={key}>{this.states[key]}</option>
        ));
    }

    render() {
        const { value, classes } = this.props;
        return (
            <div>
                <FormControl className={classes.formControl}>
                    <InputLabel shrink={true} htmlFor="state">State</InputLabel>
                    <NativeSelect native="true" inputProps={{
                        name: 'state',
                        id: 'state',
                    }}
                        value={value}
                        onChange={this.handleChange}>
                        {this.menuItems()}
                    </NativeSelect>
                </FormControl>
            </div>);
    }
});